import React from 'react'
import TreeSelect from 'components/TreeSelect'



const YearFilter = ({ state, handleYearChange, checkYear, yearFilter }) => {
  return (
    <TreeSelect
      showArrow={true}
      filterTreeNode={false}
      treeCheckable={true}
      placeholder="Select Year"
      maxTagCount={0}
      showSearch={true}
      treeDefaultExpandAll={true}
      removeTreeIndent={true}
      shadowBox
      onChange={handleYearChange}
      treeData={yearFilter || []}
      value={checkYear || []}
      height={'auto'}
      treeNodeFilterProp="title"
      autoClearSearchValue={false}
    />
  )
}

export default YearFilter
